import React from 'react';
import PropTypes from 'prop-types';

const ArchiveTickSvg = ({ color, width, height }) => {
  return (
    <svg
      width={`${width || 16}`}
      height={`${height || 16}`}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.2129 1.33331L4.78622 1.33331C3.36622 1.33331 2.21289 2.49331 2.21289 3.90665L2.21289 13.3C2.21289 14.5 3.07289 15.0066 4.12622 14.4266L7.37956 12.62C7.72622 12.4266 8.28622 12.4266 8.62622 12.62L11.8796 14.4266C12.9329 15.0133 13.7929 14.5066 13.7929 13.3V3.90665C13.7862 2.49331 12.6329 1.33331 11.2129 1.33331Z"
        stroke={color}
        strokeOpacity="0.64"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.39355 7.33335L7.39355 8.33335L10.0602 5.66669"
        stroke={color} 
        strokeOpacity="0.64"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

ArchiveTickSvg.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};

export default ArchiveTickSvg;
